<div class="spinner-container {{class}} {{size}}" [class.fx-cover]="coverParent" [class.fx-center-all]="centerAll">
    <div id="spinner" class="spinner">
        <div class="bounce1 {{color}}"></div>
        <div class="bounce2 {{color}}"></div>
        <div class="bounce3 {{color}}"></div>
    </div>
</div>
